import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import PetsIcon from "@mui/icons-material/Pets";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import VaccinesIcon from "@mui/icons-material/Vaccines";
import EventIcon from "@mui/icons-material/Event";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import * as services from "../services/services";

// ตัวอย่างข้อมูล chart
const data = [
  { day: "Mon", pets: 20, vaccines: 5 },
  { day: "Tue", pets: 25, vaccines: 8 },
  { day: "Wed", pets: 30, vaccines: 6 },
  { day: "Thu", pets: 28, vaccines: 10 },
  { day: "Fri", pets: 32, vaccines: 12 },
  { day: "Sat", pets: 40, vaccines: 15 },
  { day: "Sun", pets: 35, vaccines: 9 },
];

const Dashboard = () => {
  const [totalPets, setTotalPets] = useState(0);
  const [totalStaff, setTotalStaff] = useState(0);
  const [vaccinesToday, setVaccinesToday] = useState(0);
  const [parasitesToday, setParasitesToday] = useState(0);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      // 1. Pets
      const petsRes = await services.getPets();
      setTotalPets(petsRes.data?.data?.length || 0);

      // 2. Staff
      const usersRes = await services.getUser();
      setTotalStaff(usersRes.data?.data?.length || usersRes.data?.length || 0);

      // 3. History (Vaccines and Appointments for today)
      const histRes = await services.getHistory();
      const allHistory = histRes.data?.data || [];

      const todayStr = new Date().toISOString().split("T")[0];

      let vToday = 0;
      let pToday = 0;

      allHistory.forEach(h => {
        const hDate = h.serviceDate ? new Date(h.serviceDate).toISOString().split("T")[0] : "";
        if (hDate === todayStr) {
          if (h.serviceType === "vaccine") vToday++;
          else if (h.serviceType === "parasite") pToday++;
        }
      });

      setVaccinesToday(vToday);
      setParasitesToday(pToday);
    } catch (err) {
      console.error("Error fetching dashboard data", err);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        สรุปภาพรวม
      </Typography>

      {/* Stats Cards */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <Card sx={{ bgcolor: "#ffb74d", color: "#fff" }}>
            <CardContent>
              <PetsIcon fontSize="large" />
              <Typography variant="h6">สัตว์เลี้ยงทั้งหมด</Typography>
              <Typography variant="h4">{totalPets}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card sx={{ bgcolor: "#f57c00", color: "#fff" }}>
            <CardContent>
              <PeopleAltIcon fontSize="large" />
              <Typography variant="h6">บุคลากร</Typography>
              <Typography variant="h4">{totalStaff}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card sx={{ bgcolor: "#c2451f", color: "#fff" }}>
            <CardContent>
              <VaccinesIcon fontSize="large" />
              <Typography variant="h6">วัคซีนวันนี้</Typography>
              <Typography variant="h4">{vaccinesToday}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card sx={{ bgcolor: "#1976d2", color: "#fff" }}>
            <CardContent>
              <EventIcon fontSize="large" />
              <Typography variant="h6">ป้องกันพยาธิวันนี้</Typography>
              <Typography variant="h4">{parasitesToday}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Chart Section */}
      <Box sx={{ mt: 5 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          สถิติประจำสัปดาห์
        </Typography>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="day" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="pets" stroke="#ffb74d" activeDot={{ r: 8 }} />
            <Line type="monotone" dataKey="vaccines" stroke="#1976d2" />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default Dashboard;
